@if(searchResult)
{

    <div class="w-full md:px-[3.5rem]">

    <div id="auctions-container" class="container mx-auto mt-6   px-4 md:px-0  ">

        @if(totalResult > 0)
        {
        <h1 class="font-dm-sans text-[var(--dark-teal)] text-3xl mb-4">{{totalResult}} results for “{{query}}”</h1>

        <app-custom-breadcrumb [isColorLight]="true" [separatorIsChevron]="true"></app-custom-breadcrumb>

        <a [routerLink]="['/search-auctions']" [queryParams]="{ q: query }" class="hover:underline">
            <h3 class="text-[var(--sky-blue)] text-3xl font-medium font-noto-serif mt-10">Auctions
                ({{searchResult.auctionsCount}} results)
            </h3>
        </a>

        }


    </div>

    <div class="">
        @if(viewMode === 'image')
        {
        <app-auction-listing-vertical-view [auctions]="searchResult.auctions"
            (myAuctionChanged)="onMyAuctionsChanged($event)"></app-auction-listing-vertical-view>
        }@else{
        <app-auction-listing-horizontal-view [auctions]="searchResult.auctions"
            (myAuctionChanged)="onMyAuctionsChanged($event)"> </app-auction-listing-horizontal-view>
        }

    </div>




    <div id="auctions-container" class="container mx-auto mt-6  px-4 md:px-0 ">
        <a [routerLink]="['/search-items']" [queryParams]="{ q: query }" class="hover:underline">

            <h3 class="text-[var(--sky-blue)] text-3xl font-medium font-noto-serif mt-14 ">Items
                ({{searchResult.itemsCount}}
                results)
            </h3>
        </a>
    </div>

            @if(viewMode === 'image')
            {
            <app-item-vertical-template [items]="searchResult.items"
                (favoriteStatus)="onFavoriteChanged($event)"></app-item-vertical-template>
            }
            @else{
            <app-item-horizontal-template [items]="searchResult.items" (favoriteStatus)="onFavoriteChanged($event)">
            </app-item-horizontal-template>

            }
    
    </div>

}